const LeadershipSection = () => {
  return (
    <section id="leadership" className="section-spacing bg-zinc-50" data-testid="leadership-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-overline mb-4" data-testid="leadership-overline">Our Leader</p>
          <h2 className="heading-massive text-4xl sm:text-5xl text-black" data-testid="leadership-heading">
            Leadership
          </h2>
        </div>

        {/* Chief Apostle Feature */}
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-start" data-testid="leader-feature">
          {/* Image */}
          <div className="relative">
            <div className="aspect-[4/5] overflow-hidden">
              <img
                src="https://customer-assets.emergentagent.com/job_faith-media-hub/artifacts/0ofnqty1_79235855_2948695395154333_6835955203414425600_n.jpg"
                alt="Chief Apostle Leonard Lucas Jr."
                className="w-full h-full object-cover"
                data-testid="leader-image"
              />
            </div>
            {/* Accent box */}
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-[#FFB800] -z-10" />
          </div>

          {/* Bio Content */}
          <div>
            <p className="text-overline text-[#FFB800] mb-4">Founder & Spiritual Father</p>
            <h3 className="font-['Clash_Display'] font-semibold text-3xl md:text-4xl mb-6" data-testid="leader-name">
              Chief Apostle Leonard Lucas Jr.
            </h3>
            
            <div className="space-y-6 font-['Satoshi'] text-zinc-600 leading-relaxed">
              <p data-testid="leader-bio-1">
                Chief Apostle Leonard Lucas Jr. is a visionary leader, apostolic voice, and spiritual father whose life has been marked by a deep commitment to advancing the Kingdom of God. With decades of ministry experience, he has cultivated a legacy rooted in biblical truth, spiritual authority, and transformative leadership that impacts generations.
              </p>
              
              <p data-testid="leader-bio-2">
                Known for his unwavering dedication to sound doctrine and the demonstration of God's power, Chief Apostle Lucas carries a unique grace to establish, build, and govern ministry with wisdom and precision. His teachings emphasize spiritual maturity, discipline, and alignment with God's divine order, equipping believers to walk in purpose, authority, and kingdom identity.
              </p>
              
              <p data-testid="leader-bio-3">
                As the founder and overseer, he has played a pivotal role in shaping the spiritual foundation and apostolic culture of the ministry. His leadership extends beyond the pulpit—he is a mentor to leaders, a builder of people, and a custodian of vision. Through his guidance, countless individuals have been strengthened in faith, activated in their calling, and positioned for greater impact in both spiritual and practical dimensions of life.
              </p>
              
              <p data-testid="leader-bio-4">
                Chief Apostle Lucas is also recognized for his ability to discern times and seasons, offering prophetic insight that brings clarity, direction, and alignment to the body of Christ. His ministry is marked by integrity, spiritual depth, and a passion to see God's people walk in truth, freedom, and dominion.
              </p>
              
              <p className="font-medium text-black" data-testid="leader-bio-5">
                His legacy is one of faithfulness, sacrifice, and unwavering pursuit of God's will—raising up a generation that not only believes in God but reflects His nature and power in every area of life.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LeadershipSection;
